import React, { useEffect } from 'react';
import $ from 'jquery';
import 'daterangepicker/daterangepicker.css';
import 'daterangepicker';
import moment from 'moment';

function DateRange({ handleFilter, onFocus, value }) {
    // console.log(value);
    
    useEffect(() => {
        try {
            $('#reservation').daterangepicker({
                autoUpdateInput: false,
                autoApply: true,
                locale: {
                    format: 'YYYY-MM-DD'
                },
                startDate: value[0] ? moment(value[0], 'YYYY-MM-DD') : undefined,
                endDate: value[1] ? moment(value[1], 'YYYY-MM-DD') : undefined
            });

            $('#reservation').on('apply.daterangepicker', function (ev, picker) {
                const startDate = picker.startDate.format('YYYY-MM-DD');
                const endDate = picker.endDate.format('YYYY-MM-DD');

                $(this).val(startDate + '   ' + endDate);

                // Call handleFilter with selected dates in desired format
                handleFilter([startDate, endDate], [
                    picker.startDate.format('YYYY-MM-DD'),
                    picker.endDate.format('YYYY-MM-DD')
                ]);
            });

            $('#reservation').on('cancel.daterangepicker', function () {
                $(this).val('');
                // Call handleFilter to reset the dates
                handleFilter([], ['', '']);
            });
        } catch (error) {
            console.error("Date Range Picker initialization failed:", error);
        }

        return () => {
            $('#reservation').data('daterangepicker')?.remove();
        };
    }, [handleFilter, value]);

    const handleClear = () => {
        $('#reservation').val('');
        handleFilter([], ['', '']);
    };

    return (
        <div className="input-group">
            <input
                type="text"
                className="form-control float-right"
                id="reservation"
                placeholder="Start date     End date"
                onFocus={onFocus}
                defaultValue={value[0] && value[1] ? `${moment(value[0]).format('YYYY-MM-DD')}   ${moment(value[1]).format('YYYY-MM-DD')}` : ''}
                readOnly
            />
            <i
                className="fas fa-times"
                style={{ fontSize: "6px", color: "#bfbcbc", border: "1px solid #bfbcbc", borderRadius: "45px", padding: "5px 5px 3px 5px", height: "fit-content", cursor: "pointer", position: "absolute", right: "5px", top: "50%", transform: "translateY(-50%)" }}
                onClick={handleClear}
            ></i>
        </div>
    );
}

export default DateRange;
